import { useState, useEffect, useCallback } from 'react';
import { supabase, ScoreHistoryEntry } from '../lib/supabase';

export function useScoreHistory(userId: string | undefined, fertilityScore?: number | null) {
  const [data, setData] = useState<ScoreHistoryEntry[]>([]);
  const [loading, setLoading] = useState(true);

  const fetch = useCallback(async () => {
    if (!userId) return;
    setLoading(true);
    const { data: rpcData, error } = await supabase.rpc('get_score_history', { p_days: 7 });
    if (error) {
      console.error('get_score_history error:', error);
    } else {
      setData((rpcData as unknown as ScoreHistoryEntry[]) ?? []);
    }
    setLoading(false);
  }, [userId]);

  // Refetch on mount and whenever fertilityScore changes (i.e. after answering a question)
  useEffect(() => { fetch(); }, [fetch, fertilityScore]);

  return { data, loading };
}
